const timezoneMapping = {
    'US/Samoa': 'Americas/Samoa',
    'US/Hawaii': 'Americas/Hawaii',
    'America/Adak': 'Americas/Adak',
    "US/Aleutian": "Americas/Aleutian",
    "America/Atka": "Americas/Atka",
    "US/Alaska": "Americas/Alaska",
    "America/Anchorage": "Americas/Anchorage",
    "America/Juneau": "Americas/Juneau",
    "America/Metlakatla": "Americas/Metlakatla",
    "America/Nome": "Americas/Nome",
    "America/Sitka": "Americas/Sitka",
    "America/Yakutat": "Americas/Yakutat",
    "US/Arizona": "Americas/Arizona",
    "Canada/Pacific": "Americas/Canada/Pacific",
    "Canada/Yukon": "Americas/Canada/Yukon",
    "America/Creston": "Americas/Creston",
    "America/Dawson": "Americas/Dawson",
    "America/Dawson_Creek": "Americas/Dawson_Creek",
    "America/Ensenada": "Americas/Ensenada",
    "America/Fort_Nelson": "Americas/Fort_Nelson",
    "America/Hermosillo": "Americas/Hermosillo",
    "America/Los_Angeles": "Americas/Los_Angeles",
    "America/Mazatlan": "Americas/Mazatlan",
    "Mexico/BajaNorte": "Americas/Mexico/BajaNorte",
    "Mexico/BajaSur": "Americas/Mexico/BajaSur",
    "US/Pacific": "Americas/Pacific",
    "America/Phoenix": "Americas/Phoenix",
    "America/Santa_Isabel": "Americas/Santa_Isabel",
    "America/Tijuana": "Americas/Tijuana",
    "America/Vancouver": "Americas/Vancouver",
    "America/Whitehorse": "Americas/Whitehorse",
    "America/Bahia_Banderas": "Americas/Bahia_Banderas",
    "America/Belize": "Americas/Belize",
    "America/Boise": "Americas/Boise",
    "America/Cambridge_Bay": "Americas/Cambridge_Bay",
    "Canada/Mountain": "Americas/Canada/Mountain",
    "Canada/Saskatchewan": "Americas/Canada/Saskatchewan",
    "America/Chihuahua": "Americas/Chihuahua",
    "Chile/EasterIsland": "Americas/Chile/EasterIsland",
    "America/Ciudad_Juarez": "Americas/Ciudad_Juarez",
    "America/Costa_Rica": "Americas/Costa_Rica",
    "America/Denver": "Americas/Denver",
    "America/Edmonton": "Americas/Edmonton",
    "America/El_Salvador": "Americas/El_Salvador",
    "America/Guatemala": "Americas/Guatemala",
    "America/Inuvik": "Americas/Inuvik",
    "America/Managua": "Americas/Managua",
    "America/Merida": "Americas/Merida",
    "Mexico/General": "Americas/Mexico/General",
    "America/Mexico_City": "Americas/Mexico_City",
    "America/Monterrey": "Americas/Monterrey",
    "US/Mountain": "Americas/Mountain",
    "Navajo": "Americas/Navajo",
    "America/Regina": "Americas/Regina",
    "America/Shiprock": "Americas/Shiprock",
    "America/Swift_Current": "Americas/Swift_Current",
    "America/Tegucigalpa": "Americas/Tegucigalpa",
    "America/Yellowknife": "Americas/Yellowknife",
    "America/Atikokan": "Americas/Atikokan",
    "America/Bogota": "Americas/Bogota",
    "Brazil/Acre": "Americas/Brazil/Acre",
    "Canada/Central": "Americas/Canada/Central",
    "America/Cancun": "Americas/Cancun",
    "America/Cayman": "Americas/Cayman",
    "US/Central": "Americas/Central",
    "America/Chicago": "Americas/Chicago",
    "America/Coral_Harbour": "Americas/Coral_Harbour",
    "America/Eirunepe": "Americas/Eirunepe",
    "America/Guayaquil": "Americas/Guayaquil",
    "America/Indiana/Knox": "Americas/Indiana/Knox",
    "America/Indiana/Tell_City": "Americas/Indiana/Tell_City",
    "US/Indiana-Starke": "Americas/Indiana-Starke",
    "America/Jamaica": "Americas/Jamaica",
    "Jamaica": "Americas/Jamaica",
    "America/Knox_IN": "Americas/Knox_IN",
    "America/Lima": "Americas/Lima",
    "America/Matamoros": "Americas/Matamoros",
    "America/Menominee": "Americas/Menominee",
    "America/North_Dakota/Beulah": "Americas/North_Dakota/Beulah",
    "America/North_Dakota/Center": "Americas/North_Dakota/Center",
    "America/North_Dakota/New_Salem": "Americas/North_Dakota/New_Salem",
    "America/Ojinaga": "Americas/Ojinaga",
    "America/Panama": "Americas/Panama",
    "America/Porto_Acre": "Americas/Porto_Acre",
    "America/Rainy_River": "Americas/Rainy_River",
    "America/Rankin_Inlet": "Americas/Rankin_Inlet",
    "America/Resolute": "Americas/Resolute",
    "America/Rio_Branco": "Americas/Rio_Branco",
    "America/Winnipeg": "Americas/Winnipeg",
    "America/Anguilla": "Americas/Anguilla",
    "America/Antigua": "Americas/Antigua",
    "America/Aruba": "Americas/Aruba",
    "America/Asuncion": "Americas/Asuncion",
    "America/Barbados": "Americas/Barbados",
    "America/Blanc-Sablon": "Americas/Blanc-Sablon",
    "America/Boa_Vista": "Americas/Boa_Vista",
    "Brazil/West": "Americas/Brazil/West",
    "America/Campo_Grande": "Americas/Campo_Grande",
    "Canada/Eastern": "Americas/Canada/Eastern",
    "America/Caracas": "Americas/Caracas",
    "Chile/Continental": "Americas/Chile/Continental",
    "Cuba": "Americas/Cuba",
    "America/Cuiaba": "Americas/Cuiaba",
    "America/Curacao": "Americas/Curacao",
    "America/Detroit": "Americas/Detroit",
    "America/Dominica": "Americas/Dominica",
    "US/Eastern": "Americas/Eastern",
    "US/East-Indiana": "Americas/East-Indiana",
    "America/Fort_Wayne": "Americas/Fort_Wayne",
    "America/Grand_Turk": "Americas/Grand_Turk",
    "America/Grenada": "Americas/Grenada",
    "America/Guadeloupe": "Americas/Guadeloupe",
    "America/Guyana": "Americas/Guyana",
    "America/Havana": "Americas/Havana",
    "America/Indiana/Indianapolis": "Americas/Indiana/Indianapolis",
    "America/Indiana/Marengo": "Americas/Indiana/Marengo",
    "America/Indiana/Petersburg": "Americas/Indiana/Petersburg",
    "America/Indiana/Vevay": "Americas/Indiana/Vevay",
    "America/Indiana/Vincennes": "Americas/Indiana/Vincennes",
    "America/Indiana/Winamac": "Americas/Indiana/Winamac",
    "America/Indianapolis": "Americas/Indianapolis",
    "America/Iqaluit": "Americas/Iqaluit",
    "America/Kentucky/Louisville": "Americas/Kentucky/Louisville",
    "America/Kentucky/Monticello": "Americas/Kentucky/Monticello",
    "America/Kralendijk": "Americas/Kralendijk",
    "America/La_Paz": "Americas/La_Paz",
    "America/Louisville": "Americas/Louisville",
    "America/Lower_Princes": "Americas/Lower_Princes",
    "America/Manaus": "Americas/Manaus",
    "America/Marigot": "Americas/Marigot",
    "America/Martinique": "Americas/Martinique",
    "US/Michigan": "Americas/Michigan",
    "America/Montreal": "Americas/Montreal",
    "America/Montserrat": "Americas/Montserrat",
    "America/Nassau": "Americas/Nassau",
    "America/New_York": "Americas/New_York",
    "America/Nipigon": "Americas/Nipigon",
    "America/Pangnirtung": "Americas/Pangnirtung",
    "America/Port_of_Spain": "Americas/Port_of_Spain",
    "America/Port-au-Prince": "Americas/Port-au-Prince",
    "America/Porto_Velho": "Americas/Porto_Velho",
    "America/Puerto_Rico": "Americas/Puerto_Rico",
    "America/Santiago": "Americas/Santiago",
    "America/Santo_Domingo": "Americas/Santo_Domingo",
    "America/St_Barthelemy": "Americas/St_Barthelemy",
    "America/St_Kitts": "Americas/St_Kitts",
    "America/St_Lucia": "Americas/St_Lucia",
    "America/St_Thomas": "Americas/St_Thomas",
    "America/St_Vincent": "Americas/St_Vincent",
    "America/Thunder_Bay": "Americas/Thunder_Bay",
    "America/Toronto": "Americas/Toronto",
    "America/Tortola": "Americas/Tortola",
    "America/Virgin": "Americas/Virgin",
    "America/Araguaina": "Americas/Araguaina",
    "America/Argentina/Buenos_Aires": "Americas/Argentina/Buenos_Aires",
    "America/Argentina/Catamarca": "Americas/Argentina/Catamarca",
    "America/Argentina/ComodRivadavia": "Americas/Argentina/ComodRivadavia",
    "America/Argentina/Cordoba": "Americas/Argentina/Cordoba",
    "America/Argentina/Jujuy": "Americas/Argentina/Jujuy",
    "America/Argentina/La_Rioja": "Americas/Argentina/La_Rioja",
    "America/Argentina/Mendoza": "Americas/Argentina/Mendoza",
    "America/Argentina/Rio_Gallegos": "Americas/Argentina/Rio_Gallegos",
    "America/Argentina/Salta": "Americas/Argentina/Salta",
    "America/Argentina/San_Juan": "Americas/Argentina/San_Juan",
    "America/Argentina/San_Luis": "Americas/Argentina/San_Luis",
    "America/Argentina/Tucuman": "Americas/Argentina/Tucuman",
    "America/Argentina/Ushuaia": "Americas/Argentina/Ushuaia",
    "America/Bahia" : "Americas/Bahia",
    "America/Belem" : "Americas/Belem",
    "Brazil/East" : "Americas/Brazil/East",
    "America/Buenos_Aires" : "Americas/Buenos_Aires",
    "Canada/Atlantic" : "Americas/Canada/Atlantic",
    "America/Catamarca" : "Americas/Catamarca",
    "America/Cayenne" : "Americas/Cayenne",
    "America/Cordoba" : "Americas/Cordoba",
    "America/Fortaleza" : "Americas/Fortaleza",
    "America/Glace_Bay" : "Americas/Glace_Bay",
    "America/Goose_Bay" : "Americas/Goose_Bay",
    "America/Halifax" : "Americas/Halifax",
    "America/Jujuy" : "Americas/Jujuy",
    "America/Maceio" : "Americas/Maceio",
    "America/Mendoza" : "Americas/Mendoza",
    "America/Moncton" : "Americas/Moncton",
    "America/Montevideo" : "Americas/Montevideo",
    "America/Paramaribo" : "Americas/Paramaribo",
    "America/Punta_Arenas" : "Americas/Punta_Arenas",
    "America/Recife" : "Americas/Recife",
    "America/Rosario" : "Americas/Rosario",
    "America/Santarem" : "Americas/Santarem",
    "America/Sao_Paulo" : "Americas/Sao_Paulo",
    "America/Thule" : "Americas/Thule",
    "Canada/Newfoundland" : "Americas/Canada/Newfoundland",
    "America/St_Johns" : "Americas/St_Johns",
    "Brazil/DeNoronha" : "Americas/Brazil/DeNoronha",
    "America/Miquelon" : "Americas/Miquelon",
    "America/Noronha" : "Americas/Noronha",
    "America/Godthab" : "Americas/Godthab",
    "America/Nuuk" : "Americas/Nuuk",
    "America/Scoresbysund" : "Americas/Scoresbysund",
    "America/Danmarkshavn" : "Americas/Danmarkshavn",
    "Greenwich" : "Europe/Greenwich",
    "Iceland" : "Europe/Iceland",
    "Eire" : "Europe/Eire",
    "GB" : "Europe/GB",
    "GB-Eire" : "Europe/GB-Eire",
    "Portugal" : "Europe/Portugal",
    "Libya" : "Africa/Libya",
    "Poland" : "Europe/Poland",
    "Egypt" : "Africa/Egypt",
    "Israel" : "Asia/Israel",
    "Turkey" : "Asia/Turkey",
    "Iran" : "Asia/Iran",
    "Hongkong" : "Asia/Hongkong",
    "PRC" : "Asia/PRC",
    "Singapore" : "Asia/Singapore",
    "ROC" : "Europe/ROC",
    "Japan" : "Asia/Japan",
    "ROK" : "Asia/ROK",
    "Kwajalein" : "Pacific/Kwajalein",
    "NZ" : "Pacific/NZ",
    "NZ-CHAT" : "Pacific/NZ-CHAT"
};

// Etc/GMT zones use POSIX signs (Etc/GMT+5 is UTC-05:00), so they are listed as GMT-5 and saved back as Etc/GMT+5
for (let hours = 1; hours <= 14; hours += 1) {
    timezoneMapping[`Etc/GMT-${hours}`] = `GMT+${hours}`;
    if (hours <= 12) timezoneMapping[`Etc/GMT+${hours}`] = `GMT-${hours}`;
}

export default timezoneMapping;


// swapping the values for payload 
const swappedTimezoneMapping = Object.fromEntries(
    Object.entries(timezoneMapping).map(([key, value]) => [value, key])
);

export { swappedTimezoneMapping };

// Shows a saved timezone as the dropdown names it, only for the Etc/GMT zones whose sign reads backwards
export const displayTimezoneName = (timezone) => (timezone?.startsWith('Etc/GMT') && timezoneMapping[timezone]) || timezone;
